__turbopack_context__.v({
  "company-name": "profile-summary-module-scss-module__d7vk9a__company-name",
  "container": "profile-summary-module-scss-module__d7vk9a__container",
  "designations": "profile-summary-module-scss-module__d7vk9a__designations",
  "full-name": "profile-summary-module-scss-module__d7vk9a__full-name",
  "full-name-secondary": "profile-summary-module-scss-module__d7vk9a__full-name-secondary",
  "grace-period-indicator": "profile-summary-module-scss-module__d7vk9a__grace-period-indicator",
  "info-row": "profile-summary-module-scss-module__d7vk9a__info-row",
  "location": "profile-summary-module-scss-module__d7vk9a__location",
  "separator": "profile-summary-module-scss-module__d7vk9a__separator",
  "separator__line": "profile-summary-module-scss-module__d7vk9a__separator__line",
  "welcome": "profile-summary-module-scss-module__d7vk9a__welcome",
});
